<template>
  <div class="account-select-wrapper" v-if="visible">
    <div class="content">
      <div class="top">请选择游戏账号</div>
      <div class="list-container">
        <div
          v-for="(item, index) in accountList"
          :key="index"
          class="account-item"
          @click="onSelect(item)"
        >
          {{ item.game_account }}
        </div>
        <div v-if="accountList.length === 0" class="empty-text">暂无账号可选</div>
      </div>
    </div>
    <img class="close" :src="closeImg" alt="" @click="onClose" />
  </div>
</template>

<script>
import { on_code_verify_choose_bind } from '@/api/common';
import { choose_bind } from '@/api/tgStore';
import { CDN_URL } from '@/config/index.js';

export default {
  name: 'AccountSelectDialog',
  props: {
    dialogType: {
      type: String,
      default: '1', // 1.礼包中心、签到活动 2.太古商城
    },
  },
  data() {
    return {
      visible: false,
      accountList: [],
      phone: '', // 太古商城绑定账号还需要 phone
      closeImg: `${CDN_URL}/imperialGlory/dialog-mid-close.png`,
    };
  },
  methods: {
    open(list = [], phone = '') {
      this.accountList = list;
      this.phone = phone;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
      this.$emit('close');
    },
    onSelect(item) {
      // 绑定账号
      if (this.dialogType == '2') {
        choose_bind({ ...item, phone: this.phone })
          .then((res) => {
            if (res.code != 1) return;
            this.$emit('select', res);
            this.visible = false;
          })
          .catch((err) => {});
      } else {
        on_code_verify_choose_bind({ ...item })
          .then((res) => {
            if (res.code != 1) return;
            this.$emit('select', res);
            this.visible = false;
          })
          .catch((err) => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.account-select-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .content {
    width: 312px;
    height: 291px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 100px auto 10px auto;
    position: relative;
    display: flex;
    flex-direction: column;

    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
      flex-shrink: 0;
    }

    .list-container {
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 5px 0;

      .account-item {
        padding: 15px 20px;
        font-size: 15px;
        color: #333;
        border-bottom: 1px solid #eee;
        text-align: center;

        &:active {
          background-color: #f5f5f5;
        }

        &:last-child {
          border-bottom: none;
        }
      }

      .empty-text {
        text-align: center;
        padding: 20px;
        color: #999;
        font-size: 14px;
      }
    }
  }

  .close {
    width: 30px;
    display: block;
    margin: 0 auto;
    background-color: #fe4f4a;
    border-radius: 50%;
  }
}
</style>
